module.exports = __webpack_public_path__ + "static/image1-90973da9d80e6663a1d0f5fe9927f06b.jpg";